<mat-card-content *ngIf="data" style="height:100%">
  <form #loginForm="ngForm" enctype="multipart/form-data">
    <mat-toolbar style="float:left;clear:both;width:100%;" color="secondary">
      <div style="width:100%;float:right">
        <button mat-icon-button style="float: right; margin-left:10px; margin-right: 0" (click)="requestSeguimentTecnic($event)" matTooltip="{{ 'project-data.toolbar.seguiment' | translate }}" attr.aria-label="{{ 'project-data.toolbar.seguiment' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">bookmarks</mat-icon>
        </button>
        <button *ngIf="rol == 2 || rol == 4 || rol == 1" mat-icon-button style="float: right; margin-left:10px; margin-right: 0" (click)="requestInvoicesReb($event)" matTooltip="{{ 'project-data.toolbar.facturesRebudes' | translate }}" attr.aria-label="{{ 'project-data.toolbar.facturesRebudes' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">redeem</mat-icon>
        </button>
        <button *ngIf="rol == 2 || rol == 4 || rol == 1" mat-icon-button style="float: right; margin-left:10px; margin-right: 0" (click)="requestInvoices($event)" matTooltip="{{ 'project-data.toolbar.facturesEmeses' | translate }}" attr.aria-label="{{ 'project-data.toolbar.facturesEmeses' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">payment</mat-icon>
        </button>
        <button mat-icon-button style="float: right; margin-left:10px; margin-right: 0" (click)="this.goProposal()" matTooltip="{{ 'project-data.toolbar.proposta' | translate }}" attr.aria-label="{{ 'project-data.toolbar.proposta' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">assignment</mat-icon>
        </button>
        <button mat-icon-button style="float: right; margin-left:10px; margin-right: 0" (click)="this.goBack()" matTooltip="{{ 'project-data.toolbar.llistaTreballs' | translate }}" attr.aria-label="{{ 'project-data.toolbar.llistaTreballs' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">view_headline</mat-icon>
        </button>
        <button *ngIf="rol == 2 || rol == 4 || rol == 1" mat-icon-button style="float: right; margin-right:0" (click)="onSubmit()" [disabled]='!espotDesar' matTooltip="{{ 'project-data.toolbar.desar' | translate }}" attr.aria-label="{{ 'project-data.toolbar.desar' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">save</mat-icon>
        </button>
        <button *ngIf="rol == 2 || rol == 4 || rol == 1" mat-icon-button style="float: right; margin-right:0" (click)="exportFitxa()" matTooltip="{{ 'project-data.toolbar.exportar' | translate }}" attr.aria-label="{{ 'project-data.toolbar.exportar' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">download</mat-icon>
        </button>
      </div>  
    </mat-toolbar>
    <mat-progress-bar mode="indeterminate" color="warm" *ngIf="showAsyncProgress"></mat-progress-bar>
    <mat-card-content style="float:left;clear:none;width:100%;background-color: #dee8f4;padding: 0px;margin-top: 20px">
     <div style="padding: 10px 10px">

<mat-card-content style="float: right; padding: 0; display: flex; flex-direction: row; gap: 8px;">

  <!-- TREBALL DESTACAT -->
  <label class="badge-toggle" [class.active]="data.destacat">
    <mat-checkbox (change)="setDestacat($event)"
                  name="destacat"
                  [ngModel]="data.destacat"
                  color="primary">
    </mat-checkbox>
    <mat-icon class="badge-icon">star</mat-icon>
    <span class="badge-label">{{ 'project-data.badges.destacat' | translate }}</span>
  </label>

  <!-- PROJECTE INNOVADOR -->
  <label class="badge-toggle innovador_tooltip" [class.active]="data.innovador"
       matTooltip="{{ 'project-data.badges.innovadorToolTip' | translate }}" matTooltipClass="custom-tooltip" matTooltipPosition="above">
    <mat-checkbox (change)="setInnovador($event)"
                  name="innovador"
                  [ngModel]="data.innovador"
                  color="primary">
    </mat-checkbox>
    <mat-icon class="badge-icon">emoji_objects</mat-icon>
    <span class="badge-label">{{ 'project-data.badges.innovador' | translate }}</span>
  </label>

</mat-card-content>

    <h2 mat-line style="width:90%">{{ 'project-data.titol' | translate }} {{ !data.data_finalitzacio ? ('project-data.titolNou' | translate) : '' }}</h2>
    <div class="equiWCol" style="width: 100%">
      <mat-form-field style="width: 40%">
       <input matInput [readonly]="!isNew" placeholder="{{ 'project-data.camps.nomDescripcio' | translate }}" name="Nom"
        disabled list="projectList" [(ngModel)]="data.clau" ngDefaultControl/>
      </mat-form-field>
      <mat-form-field style="width:20%">
        <input matInput placeholder="{{ 'project-data.camps.codi' | translate }}" name="codi" [(ngModel)]="data.codi" ngDefaultControl disabled style="width:100%;color:#777777"/>
      </mat-form-field>
      <mat-form-field style="width:20%">
        <input matInput placeholder="{{ 'project-data.camps.codiSage' | translate }}" name="codisage" maxlength="15" [(ngModel)]="data.codisage" ngDefaultControl disabled style="width:100%;color:#777777"/>
      </mat-form-field>
      <div style="float:left;clear:none;padding-top:0px;padding-left:20px;width:40%;display:none">
        <mat-form-field style="width:100%;display:none">
          <input matInput placeholder="{{ 'project-data.camps.descripcioSage' | translate }}" name="descrsage" [(ngModel)]="data.descrsage" ngDefaultControl disabled style="color:#777777"/>
        </mat-form-field>
      </div>
    </div>
    <div class="equiWCol">
      <mat-form-field style="width: 100%">
        <input matInput placeholder="{{ 'project-data.camps.titolOficial' | translate }}" name="titol" [(ngModel)]="data.titol" readonly ngDefaultControl style='font-weight: bold'/>
      </mat-form-field>
    </div>
    <div class="equiWCol">
      <mat-form-field style="width: 100%">
        <input matInput placeholder="{{ 'project-data.camps.titolMcrit' | translate }}" name="titol_oficial" [(ngModel)]="data.titol_oficial" readonly ngDefaultControl style='font-weight: bold'/>
      </mat-form-field>
    </div>
    <div class="equiWCol">
       <mat-form-field style="width: 100%">
        <input matInput placeholder="{{ 'project-data.camps.etiquetes' | translate }}" name="tematica" readonly
          [(ngModel)]="data.tematica" ngDefaultControl/>
       </mat-form-field>
    </div>
    <div class="equiWCol">
       <mat-form-field style="width: 33%">
        <input matInput placeholder="{{ 'project-data.camps.serveis' | translate }}" name="tematica2" readonly
          [(ngModel)]="data.tematica2" ngDefaultControl/>
       </mat-form-field>
       <mat-form-field style="width: 33%">
        <input matInput placeholder="{{ 'project-data.camps.sectors' | translate }}" name="tematica3" readonly
          [(ngModel)]="data.tematica3" ngDefaultControl/>
       </mat-form-field>
      </div>
      <div class="equiWCol">
       <mat-form-field>
        <input matInput readonly placeholder="{{ 'project-data.camps.empresa' | translate }}" name="empresa"
          [(ngModel)]="data.empresa" ngDefaultControl/>
       </mat-form-field>
       <mat-form-field>
        <input matInput readonly placeholder="{{ 'project-data.camps.tipusParticipacio' | translate }}" name="participacio"
          [(ngModel)]="data.tipus_participacio" ngDefaultControl/>
       </mat-form-field>
        <!-- Hi havia el camp calculat "duradaProjecte" -->
       <mat-form-field style="width:100px">
        <input matInput placeholder="{{ 'project-data.camps.duradaMesos' | translate }}" name="durada_mesos" readonly
          [(ngModel)]="data.durada_mesos" ngDefaultControl/>
       </mat-form-field>
             <mat-form-field style="width: 20%">
       <input matInput placeholder="{{ 'project-data.camps.ambitProposta' | translate }}" name="ambit_proposta"
        [(ngModel)]="data.ambit_proposta" readonly ngDefaultControl/>
      </mat-form-field>
      <mat-form-field style="width: 20%">
       <input matInput placeholder="{{ 'project-data.camps.estatProposta' | translate }}" name="estat_proposta"  [ngStyle]="{'color': (data.estat_proposta != 'Contractada') ? 'red' : 'green'}" [(ngModel)]="data.estat_proposta" readonly ngDefaultControl/>
      </mat-form-field>
      </div>
     </div>
    </mat-card-content>

    <mat-card-content style="width:100%;float:left;clear:left;padding:5px">
      <div style="float:left;clear:both;width:100%;padding:5px">
       <mat-form-field style="float: left;clear: left;width:10%">
        <input matInput placeholder="{{ 'project-data.seguiment.data' | translate }}" name="dia" type="date" [(ngModel)]="dia" ngDefaultControl/>
       </mat-form-field>
       <button color="primary" mat-icon-button matTooltip="{{ 'project-data.seguiment.afegirDataToolTip' | translate }}" attr.aria-label="{{ 'project-data.seguiment.afegirDataToolTip' | translate }}" matTooltipClass="tooltip-style" (click)="afegir(null)" style="margin-top:15px;float: left;clear: none;width:2%">
         <mat-icon style="font-size:24px;font-weight:bold">note_add</mat-icon>
       </button>
       <mat-form-field style="width:40%;float:left;clear:none;margin-top:10px;margin-left: 20px;height:40px">
        <mat-select style="width:100%" placeholder="{{ 'project-data.seguiment.seguimentTreballs' | translate }}" (selectionChange)="afegir($event)">
          <mat-option *ngFor="let tipus of seguimentsTreballs" [value]="tipus.value">{{tipus.text}}</mat-option>
        </mat-select>
       </mat-form-field>
      </div>
      <div style="float:left;clear:both;margin-top:0px;width:95%;padding-left: 5px">
         <quill-editor #quillEditor [styles]="{height: '200px', backgroundColor: '#EEEEEE'}" [(ngModel)]="data.nota" name="nota" placeholder="{{ 'project-data.seguiment.seguimentTreballsPlaceholder' | translate }}" (onSelectionChanged)="setPos($event)"></quill-editor>
         <button color="primary" mat-icon-button matTooltip="{{ 'project-data.seguiment.afegirDataToolTip' | translate }}" attr.aria-label="{{ 'project-data.seguiment.afegirDataToolTip' | translate }}" matTooltipClass="tooltip-style" (click)="afegirE()" style="float: left;clear: none;width:2%">
         <mat-icon style="font-size:24px;font-weight:bold">note_add</mat-icon>
         </button>
         <textarea style="width:100%;height:'100px';backgroundColor:'#dee8f4'" [(ngModel)]="data.nota_e" name="nota_e" placeholder="{{ 'project-data.seguiment.supervisio' | translate }}" (onSelectionChanged)="setPos($event)"></textarea>
      </div>
    </mat-card-content>

    <mat-card-content style="float:left;clear:left;width:100%">
      <div style="float:left;clear:left;width:20%"> 
        <h3 mat-line [title]="!espotDesar ? ('project-data.estatTreball.seleccionarOpcio' | translate) : ''" [ngClass]="!espotDesar?'color':'red'">{{ 'project-data.estatTreball.titol' | translate }}</h3>
        <mat-form-field style="width:100%">
          <mat-select style="margin-top:5px;width:100%;height:19px" [(ngModel)]="data.estat_projecte" [ngModelOptions]="{standalone: true}" placeholder="{{ 'project-data.estatTreball.placeholder' | translate }}" (change)="esDesable()">
            <!-- <mat-option *ngFor="let state of possibleStates" [value]="state" [selected]="state === data.estat_projecte">{{state}}</mat-option> -->
            <mat-option *ngFor="let opcio of possibleStates" [value]="opcio.codi">
              {{ opcio.text }}
            </mat-option>

          </mat-select>
        </mat-form-field>
      </div>
      <div style="float:left;clear:left;width:25%">
          <h3 mat-line style="margin-bottom:12px">{{ 'project-data.expedient.titol' | translate }}</h3>
          <mat-form-field style="width:100%">
            <input matInput placeholder="{{ 'project-data.expedient.placeholder' | translate }}" name="expedient" [(ngModel)]="data.expedient" ngDefaultControl/>
          </mat-form-field> 
        </div>
        <div style="float:left;clear:left;width:42%">
          <h3 mat-line style="margin-bottom:0px">{{ 'project-data.descProjecte' | translate }}</h3>
          <mat-form-field style="width:100%">
            <textarea matInput placeholder="" name="desc_projecte" rows="5" [(ngModel)]="data.desc_projecte"  style="width: 100%;height:60px">
            </textarea>
          </mat-form-field> 
        </div>
         <div style="float:left;clear:none;margin-left:1%;width:42%">
          <h3 mat-line style="margin-bottom:0px">{{ 'project-data.descServeis' | translate }}</h3>
          <mat-form-field style="width:100%">
            <textarea matInput placeholder="" name="desc_serveis" rows="5" [(ngModel)]="data.desc_serveis"  style="width: 100%;height:60px">
            </textarea>
          </mat-form-field> 
        </div>

<div style="display:flex; gap:2rem; align-items:flex-start; width:100%;background-color: #dee8f4;padding:5px">

  <!-- Bloc esquerre -->
  <div style="flex:1;">
    <h3 mat-line style="margin-bottom:0;">{{ 'project-data.innovacio.titol' | translate }}</h3>

    <mat-form-field style="width:100%;">
      <textarea
        matInput
        name="innovacio"
        rows="5"
        [(ngModel)]="data.innovacio"
        style="height:60px;">
      </textarea>
    </mat-form-field>
  </div>

  <!-- Bloc dret -->
  <div style="display:flex; flex-direction:column; gap:0.5rem; min-width:250px;padding-top:20px">

    <mat-checkbox
      attr.aria-label="{{ 'project-data.innovacio.incrementalToolTip' | translate }}"
      matTooltip="{{ 'project-data.innovacio.incrementalToolTip' | translate }}"
      name="inno_incr"
      [(ngModel)]="data.inno_incr">
      {{ 'project-data.innovacio.incrementalLabel' | translate }}
    </mat-checkbox>

    <mat-checkbox
      attr.aria-label="{{ 'project-data.innovacio.adjacentToolTip' | translate }}"
      matTooltip="{{ 'project-data.innovacio.adjacentToolTip' | translate }}"
      name="inno_adj"
      [(ngModel)]="data.inno_adj">
      {{ 'project-data.innovacio.adjacentLabel' | translate }}
    </mat-checkbox>

    <mat-checkbox
      attr.aria-label="{{ 'project-data.innovacio.disruptivaToolTip' | translate }}"
      matTooltip="{{ 'project-data.innovacio.disruptivaToolTip' | translate }}"
      name="inno_dis"
      [(ngModel)]="data.inno_dis">
      {{ 'project-data.innovacio.disruptivaLabel' | translate }}
    </mat-checkbox>

  </div>

</div>

        <div style="float:left;clear:left;width:210px">
         <h3 mat-line [title]="!espotDesar ? ('project-data.estatTreball.seleccionarOpcio' | translate) : ''" [ngStyle]="{'color':!espotDesar?'red':'rgb(0,0,0,0.87)'}">{{ 'project-data.certificat.titol' | translate }}</h3>
          <mat-form-field style="width:100%">
            <mat-select style="margin-top:5px" [(ngModel)]="data.certificat" [ngModelOptions]="{standalone: true}" placeholder="{{ 'project-data.certificat.placeholder' | translate }}" (change)="esDesable()">
              <mat-option value="No aplicable">{{ 'project-data.certificat.noAplicable' | translate }}</mat-option>
              <mat-option value="Rebut">{{ 'project-data.certificat.rebut' | translate }}</mat-option>
              <mat-option value="Demanat">{{ 'project-data.certificat.demanat' | translate }}</mat-option>
              <mat-option value="Pendent">{{ 'project-data.certificat.pendent' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div style="float:left;clear:none;width:170px;padding-left:20px"> 
          <h3 mat-line>{{ 'project-data.urbanistica.titol' | translate }}</h3>
          <mat-form-field style="width:100%">
            <mat-select style="margin-top:5px;width:100%;height:19px" [(ngModel)]="data.estat_pla" [ngModelOptions]="{standalone: true}" placeholder="{{ 'project-data.urbanistica.placeholder' | translate }}">
              <mat-option value="No aplica">{{ 'project-data.urbanistica.noAplica' | translate }}</mat-option>
              <mat-option value="No aprovat">{{ 'project-data.urbanistica.noAprovat' | translate }}</mat-option>
              <mat-option value="Aprovat inicialment">{{ 'project-data.urbanistica.aprovatInicialment' | translate }}</mat-option>
              <mat-option value="Aprovat provisionalment">{{ 'project-data.urbanistica.aprovatProvisionalment' | translate }}</mat-option>
              <mat-option value="Aprovat definitiu">{{ 'project-data.urbanistica.aprovatDefinitiu' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div style="float:left;clear:none;margin-left:1%;width:160px">
         <h3 mat-line [title]="!espotDesar ? ('project-data.estatTreball.seleccionarOpcio' | translate) : ''" [ngStyle]="{'color':!espotDesar?'red':'rgb(0,0,0,0.87)'}">{{ 'project-data.fitxaCreada.titol' | translate }}</h3>
          <mat-form-field style="width:100%">
            <mat-select style="margin-top:5px" [(ngModel)]="data.fitxa_descriptiva" [ngModelOptions]="{standalone: true}" placeholder="{{ 'project-data.fitxaCreada.placeholder' | translate }}" (change)="esDesable()">
              <mat-option value="No aplicable">{{ 'project-data.fitxaCreada.noAplicable' | translate }}</mat-option>
              <mat-option value="Rebut">{{ 'project-data.fitxaCreada.acabada' | translate }}</mat-option>
              <mat-option value="Pendent">{{ 'project-data.fitxaCreada.pendent' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div style="float:left;clear:both" *ngIf="data.estat_projecte=='Finalitzat pendent de cobrament'">{{ 'project-data.avisCertificat' | translate }}</div>
       <div style="float:left;clear:left;width: 100%;padding:5px;background-color:#dee8f4"> 
       <div style="float:left;clear:left;width: 100%">
         <h3 mat-line>{{ 'project-data.dates.titol' | translate }}</h3>
       </div> 
       <div style="float:left;clear:left;width: 100%"> 
         <mat-form-field style="width:160px"> 
          <input matInput type="date" style="width:160px"
          placeholder="{{ 'project-data.dates.adjudicacio' | translate }}" name="dataAprovacio"
          [(ngModel)]="data.data_aprovacio" ngDefaultControl
        />
        </mat-form-field>
        <mat-form-field style="width:160px;margin-left:1%">    
         <input matInput type="date" style="width:160px"
           placeholder="{{ 'project-data.dates.signatura' | translate }}" name="dataSignatura" (change)="computeProjectLength(data)"
          [(ngModel)]="data.data_signatura" ngDefaultControl
        />
        </mat-form-field>
        <mat-form-field style="width:160px;margin-left:1%">
          <input matInput type="date" style="width:160px"
          placeholder="{{ 'project-data.dates.garantia' | translate }}" name="dataGarantia"
          [(ngModel)]="data.data_pagament_garantia" ngDefaultControl
        />
        </mat-form-field>
        <mat-form-field style="width:160px;margin-left:1%">
          <input matInput type="date" style="width:160px"
          placeholder="{{ 'project-data.dates.finalitzacio' | translate }}" name="dataFinalitzacio" (change)="computeProjectLength(data)"
          [(ngModel)]="data.data_finalitzacio" ngDefaultControl
        />
        </mat-form-field>
        <mat-form-field style="width:160px;margin-left:1%">
          <input matInput type="date" style="width:160px"
          placeholder="{{ 'project-data.dates.devolucioGarantia' | translate }}" name="dataDevGarantia"
          [(ngModel)]="data.data_dev_garantia" ngDefaultControl
        />
        </mat-form-field>
       </div>
      </div>
    </mat-card-content>
    <mat-card-content style="float:left;clear:left;width:100%;background-color:#EEEEEE;padding:5px">
       <div style="float:left;clear:left;width:100%">
        <h3 mat-line>{{ 'project-data.contractacio.titol' | translate }}
          <button mat-icon-button style="clear:none;padding-left:10px;font-size:10px" color="primary"
            (click)="openCurrencyDialog()"
            matTooltip="{{ 'project-data.contractacio.canviMonedaToolTip' | translate }}"
            attr.aria-label="{{ 'project-data.contractacio.canviMonedaAriaLabel' | translate }}">
            <mat-icon>currency_exchange</mat-icon>
        </button></h3>
       </div>
       <div style="float:left;clear:left;width:100%">
        <div style="float:left;clear:left;width:100%"> 
         <mat-form-field style="width:170px">
          <input matInput type="number" step="0.01" style="width:170px" matTooltip="{{ 'project-data.contractacio.pressupostGlobalToolTip' | translate }}"
          placeholder="{{ 'project-data.contractacio.pressupostGlobal' | translate }}" name="pressupost_projecte_loc" matTooltipHideDelay="100000"
          [(ngModel)]="data.pressupost_projecte_loc" formatNumberPipe ngDefaultControl
         />
         </mat-form-field>
         <mat-form-field style="width:100px">
           <mat-select style="" [(ngModel)]="data.moneda_press_proj" placeholder="{{ 'project-data.contractacio.moneda' | translate }}" name="moneda_press_proj">
             <!--<mat-option *ngFor="let moneda of possibleMonedes" [value]="moneda.value" [selected]="moneda.value === data.moneda_press_proj">{{moneda.text}}</mat-option>-->
             <mat-option *ngFor="let opcio of possibleMonedes" [value]="opcio.codi">
              {{ opcio.text }}
             </mat-option>
           </mat-select>
         </mat-form-field>
         <mat-form-field style="width:100px">  
          <input matInput type="number" step="0.01" style="width:100px"
          placeholder="{{ 'project-data.contractacio.canvi' | translate }}" name="canvi_moneda_press_proj"
          [(ngModel)]="data.canvi_moneda_press_proj" formatNumberPipe ngDefaultControl
         />
         </mat-form-field>
         <mat-form-field style="width:170px">
          <input matInput type="number" disabled style="width:170px;color:#777777"
          placeholder="{{ 'project-data.contractacio.pressupostGlobalEur' | translate }}"
          value="{{data.canvi_moneda_press_proj*data.pressupost_projecte_loc}}" formatNumberPipe
         />
         </mat-form-field>         
         </div>
        <div style="float:left;clear:left;width:100%"> 
           <mat-form-field style="width:170px">
             <input matInput type="number" step="0.01" style="width:170px" matTooltip="{{ 'project-data.contractacio.pressupostContractatToolTip' | translate }}"
             placeholder="{{ 'project-data.contractacio.pressupostContractat' | translate }}" name="pressupost_contractat_loc" matTooltipHideDelay="100000"
             [(ngModel)]="data.pressupost_contractat_loc" formatNumberPipe ngDefaultControl
           />
           </mat-form-field>
           <mat-form-field style="width:100px">
             <mat-select style="width:100px" [(ngModel)]="data.moneda_pagament" placeholder="{{ 'project-data.contractacio.moneda' | translate }}" name="moneda_pagament">
               <!-- <mat-option *ngFor="let moneda of possibleMonedes" [value]="moneda.value" [selected]="moneda.value === data.moneda_pagament">{{moneda.text}}</mat-option> -->
               <mat-option *ngFor="let opcio of possibleMonedes" [value]="opcio.codi">
                  {{ opcio.text }}
               </mat-option>
             </mat-select>
           </mat-form-field>
           <mat-form-field style="width:100px">
             <input matInput type="number" step="0.01" style="width:100px"
             placeholder="{{ 'project-data.contractacio.canvi' | translate }}" name="canvi_moneda"
             [(ngModel)]="data.canvi_moneda" formatNumberPipe ngDefaultControl
             />
            </mat-form-field>
            <mat-form-field style="width:170px">
              <input matInput type="number" disabled style="width:170px;color:#777777"
               placeholder="{{ 'project-data.contractacio.pressupostContractatEur' | translate }}" 
               value="{{data.pressupost_contractat_loc*data.canvi_moneda}}" formatNumberPipe
              />
            </mat-form-field>
            <mat-form-field style="width:100px">
              <input matInput type="number" step="0.1" style="width:100px"
               placeholder="{{ 'project-data.contractacio.preuHora' | translate }}" name="preu_hora"
               [(ngModel)]="data.preu_hora" formatNumberPipe:2 ngDefaultControl
              />
            </mat-form-field>
            <mat-form-field style="width:170px">
              <input matInput type="number" step="0.01" style="width:170px"
               placeholder="{{ 'project-data.contractacio.impostosIva' | translate }}" name="impostos"
               [(ngModel)]="data.import_impostos" formatNumberPipe ngDefaultControl
              />
            </mat-form-field> 
            <mat-form-field style="width:170px">
              <input matInput type="number" step="0.01" style="width:170px"
               placeholder="{{ 'project-data.contractacio.impostosLocal' | translate }}" name="impostos_loc"
               [(ngModel)]="data.import_impostos_loc" formatNumberPipe ngDefaultControl
              />
            </mat-form-field>
        </div>
        <div style="float:left;clear:left;width:100%">
         <mat-form-field style="width:170px">
            <mat-select style="margin-top:4px;width:100%;height:19px" [(ngModel)]="data.tipus_garantia" [ngModelOptions]="{standalone: true}" placeholder="{{ 'project-data.contractacio.tipusGarantia' | translate }}">
              <!-- <mat-option *ngFor="let tipus of possibleTipGarantia" [value]="tipus.text" [selected]="tipus.text === data.tipus_garantia">{{tipus.text}}</mat-option> -->
              <mat-option *ngFor="let opcio of possibleTipGarantia" [value]="opcio.codi">
                {{ opcio.text }}
              </mat-option>
            </mat-select>
         </mat-form-field>
         <mat-form-field style="width:170px">
           <input matInput type="number" step="0.01" style="width:170px"
          placeholder="{{ 'project-data.contractacio.importGarantia' | translate }}" name="garantia"
          [(ngModel)]="data.pressupost_garantia" formatNumberPipe ngDefaultControl
          />
         </mat-form-field>
         <mat-form-field style="width:100px">
           <mat-select style="width:100px" [(ngModel)]="data.moneda_garantia" placeholder="{{ 'project-data.contractacio.moneda' | translate }}" name="moneda_garantia">
            <!-- <mat-option *ngFor="let moneda of possibleMonedes" [value]="moneda.value" [selected]="moneda.value === data.moneda_garantia">{{moneda.text}}</mat-option> -->
            <mat-option *ngFor="let opcio of possibleMonedes" [value]="opcio.codi">
              {{ opcio.text }}
            </mat-option>
           </mat-select>
         </mat-form-field>
         <mat-form-field style="width:100px">
          <input matInput type="number" step="0.01" style="width:100px"
          placeholder="{{ 'project-data.contractacio.canvi' | translate }}" name="canvi_moneda_garantia"
          [(ngModel)]="data.canvi_moneda_garantia" formatNumberPipe ngDefaultControl
         />
         </mat-form-field>
         <mat-form-field style="width:170px">
          <input matInput type="number" disabled style="width:170px;color:#777777"
          placeholder="{{ 'project-data.contractacio.importGarantiaEur' | translate }}"
          value="{{data.canvi_moneda_garantia*data.pressupost_garantia}}" formatNumberPipe
         />
         </mat-form-field>
         <mat-form-field style="width:170px">
          <input matInput type="number" step="0.01" style="width:170px" name="viatges" placeholder="{{ 'project-data.contractacio.previsioViatges' | translate }}" [(ngModel)]="data.viatges" formatNumberPipe ngDefaultControl/>
         </mat-form-field> 
        </div>

        <div style="float:left;clear:left; width:100%;padding-bottom:10px;background-color:#EEEEEE">
         <h3 mat-line style="margin-top:10px">{{ 'project-data.subcontractacio.titol' | translate }}</h3>
         <label *ngIf="percentatge_subcon>0.3 && percentatge_subcon<=1" style="font-size:0.85em;font-weight:bold">{{ 'project-data.subcontractacio.avis30' | translate }}</label>
         <label *ngIf="percentatge_subcon>1" style="font-size:0.85em;color:#FF0000;font-weight:bold">{{ 'project-data.subcontractacio.avis100' | translate }}</label>
        </div>
        <div style="float:left;clear:left;width:100%"> 
         <mat-form-field style="width:170px">
          <input matInput type="number" step="0.01" style="width:170px" matTooltip="{{ 'project-data.subcontractacio.previsioToolTip' | translate }}"
           [style.color]="(percentatge_subcon>0.3)?'#FF0000':'#000000'"  matTooltipHideDelay="100000"
           [style.font-weight]="(percentatge_subcon>0.3)?'bold':'normal'"
           placeholder="{{ 'project-data.subcontractacio.previsio' | translate }}" name="pressupost_subcon"
           [title]="(percentatge_subcon>0.3) ? ('project-data.subcontractacio.titleSupera30' | translate) : ('project-data.subcontractacio.titlePressupostSubcon' | translate)"
           [(ngModel)]="data.pressupost_subcon" formatNumberPipe ngDefaultControl
         />
         </mat-form-field>
         <mat-form-field style="width:100px">
           <mat-select style="width:100px" [(ngModel)]="data.moneda_subcon" placeholder="{{ 'project-data.contractacio.moneda' | translate }}" name="moneda_subcon">
            <!-- <mat-option *ngFor="let moneda of possibleMonedes" [value]="moneda.value" [selected]="moneda.value === data.moneda_subcon">{{moneda.text}}</mat-option> -->
            <mat-option *ngFor="let opcio of possibleMonedes" [value]="opcio.codi">
              {{ opcio.text }}
            </mat-option>
           </mat-select>
         </mat-form-field>
         <mat-form-field style="width:100px">
          <input matInput type="number" step="0.01" style="width:100px"
          placeholder="{{ 'project-data.contractacio.canvi' | translate }}" name="canvi_moneda_subcon"
          [(ngModel)]="data.canvi_moneda_subcon" formatNumberPipe ngDefaultControl
         />
         </mat-form-field>
         <mat-form-field style="width:170px">
          <input matInput type="number" disabled style="width:170px;color:#777777"
          placeholder="{{ 'project-data.subcontractacio.previsioEur' | translate }}"
          value="{{data.pressupost_subcon*data.canvi_moneda_subcon}}" formatNumberPipe
         />
         </mat-form-field> 
         <mat-form-field style="width:170px">
          <input matInput type="number" disabled style="width:170px" placeholder="{{ 'project-data.subcontractacio.facturada' | translate }}" name="subcontractacio" [(ngModel)]="data.subcontractacio" formatNumberPipe ngDefaultControl [style.color]="(subcontractacio>=percentatge_subcon*canvi_moneda_subcon)?'#FF0000':'#777777'" [title]="(subcontractacio>=percentatge_subcon*canvi_moneda_subcon) ? ('project-data.subcontractacio.titleSuperaReal' | translate) : ('project-data.subcontractacio.titlePressupostSegonsFactures' | translate)"
          />
          </mat-form-field>
        </div>
        <h3 mat-line style="margin-top:10px">{{ 'project-data.importPropi.titol' | translate }}</h3>
        <div style="float:left;clear:left;width:100%">
         <mat-form-field style="float:left;clear:none;width:170px">
          <input matInput type="number" disabled style="width:170px;color:#777777" placeholder="{{ 'project-data.importPropi.eur' | translate }}" name="pressupost_propi"
          value="{{data.pressupost_contractat_loc*data.canvi_moneda - data.pressupost_subcon*data.canvi_moneda_subcon}}" formatNumberPipe ngDefaultControl
         />
         </mat-form-field>
         <mat-form-field style="float:left;clear:none;width:170px;padding-left:!%">
          <input matInput type="number" disabled style="width:170px;color:#777777" placeholder="{{ 'project-data.importPropi.loc' | translate }}" name="pressupost_propi"
          value="{{data.pressupost_contractat_loc- data.pressupost_subcon}}" formatNumberPipe ngDefaultControl
         />
         </mat-form-field>
         </div>
       </div>
    </mat-card-content>
    <mat-card-content style="float:left;clear:left; width:100%;margin-bottom:40px">
      <div style="float:left;clear:left; width:100%;margin-bottom:20px;height:50px">
        <mat-form-field style="float:left;clear:none;width:80%">
          <input matInput style="width:100%" placeholder="{{ 'project-data.url' | translate }}" name="url" [(ngModel)]="data.url" ngDefaultControl/>
        </mat-form-field>
        <div class="lbl_dlg" style="float:left;clear:none;margin-left:10px;padding-top:25px;width:30px" *ngIf="data.url">
          <a href="{{data.url}}" style="color:#3f51b5" target="_blank"><mat-icon>cloud_circle</mat-icon></a>
        </div>
      </div>
<!--      <div style="float:left;clear:left; width:100%;margin-bottom:0px;height:30px">
        <div class="lbl_dlg" style="font-weight:bold;padding-top:7px;float:left;clear:left;width:300px">Documentació contractual associada:</div>
        <div class="lbl_dlg" style="float:left;clear:none;margin-left:10px;margin-top:5px" *ngIf="data.filename"><a href="#" (click)="desarFitxer($event,data.filename,'documents/treballs')" alt="Veure l'arxiu (si s'ha desat el formulari previament)">{{data.filename}}</a>
        </div>
        <div class="lbl_dlg" style="margin-left:10px;padding-top:7px" *ngIf="data.filename">
          <mat-icon style="font-size:24px;margin-left: 20px; margin-right: 1em;margin-top: -20px;cursor:pointer" (click)="data.filename=''" color="primary">delete_forever</mat-icon>
        </div>
      </div>
      <div style="float:left;clear:left;width:100%">
        <div style="float:left;clear:left;position: absolute;width:100%;z-index:1;background-color: white">
          <div style="float:left;clear:none;padding-top:5px">Carregar un document</div>
          <div style="float:left;clear:none">
            <label for="file">
              <mat-icon style="font-size:24px;margin-left: 20px; margin-right: 1em;cursor:pointer" color="primary" matTooltip="L'extensió del fitxer ha de'estar en minúscules." aria-label="L'extensió del fitxer ha de'estar en minúscules." matTooltipClass="tooltip-style">cloud_upload</mat-icon></label>
          </div>
        </div>
        <div style="float:left;clear:left;position: absolute;width:100%">
          <input mat-raised-button color="primary" type="file" filter="jpg;png;doc;docx;pdf;xls;xlsx;gif;zip;rar;odt;ods;ppt;pptx" style="width:80%" placeholder="" id="file" name="file" (change)="onFileChange($event, 'file')"/> (100Mb màx.)
        </div>
      </div>
    </mat-card-content>
    <mat-card-content style="float:left;clear:left; width:100%;margin-bottom:40px">
      <div style="float:left;clear:left; width:100%;margin-bottom:0px;height:30px">
        <div class="lbl_dlg" style="font-weight:bold;padding-top:7px;float:left;clear:left;width:300px">Fitxa associada:</div>
        <div class="lbl_dlg" style="float:left;clear:none;margin-left:10px;margin-top:5px" *ngIf="data.fitxaname"><a href="#" (click)="desarFitxer($event,data.fitxaname,'documents/treballs')" alt="Veure l'arxiu (si s'ha desat el formulari previament)">{{data.fitxaname}}</a>
        </div>
        <div class="lbl_dlg" style="margin-left:10px;padding-top:7px" *ngIf="data.fitxaname">
          <mat-icon style="font-size:24px;margin-left: 20px; margin-right: 1em;margin-top: -20px;cursor:pointer" (click)="data.fitxaname=''" color="primary">delete_forever</mat-icon>
        </div>
      </div>
      <div style="float:left;clear:left;width:100%">
        <div style="float:left;clear:left;position: absolute;width:100%;z-index:1;background-color: white">
          <div style="float:left;clear:none;padding-top:5px">Carregar la fitxa</div>
          <div style="float:left;clear:none">
            <label for="fitxa">
              <mat-icon style="font-size:24px;margin-left: 20px; margin-right: 1em;cursor:pointer" color="primary" matTooltip="L'extensió del fitxer ha de'estar en minúscules." aria-label="L'extensió del fitxer ha de'estar en minúscules." matTooltipClass="tooltip-style">cloud_upload</mat-icon></label>
          </div>
        </div>
        <div style="float:left;clear:left;position: absolute;width:100%">
          <input mat-raised-button color="primary" type="file" filter="jpg;png;doc;docx;pdf;xls;xlsx;gif;zip;rar;odt;ods;ppt;pptx" style="width:80%" placeholder="" id="fitxa" name="fitxa" (change)="onFileChange($event, 'fitxa')"/> (100Mb màx.)
        </div>
      </div>
    </mat-card-content>
    <mat-card-content style="float:left;clear:left; width:100%;margin-bottom:40px">
      <div style="float:left;clear:left; width:100%;margin-bottom:0px;height:30px">
        <div class="lbl_dlg" style="font-weight:bold;padding-top:7px;float:left;clear:left;width:300px">Cerfiticat:</div>
        <div class="lbl_dlg" style="float:left;clear:none;margin-left:10px;margin-top:5px" *ngIf="data.certifname"><a href="#" (click)="desarFitxer($event,data.certifname,'documents/treballs/certificats')" alt="Veure l'arxiu (si s'ha desat el formulari previament)">{{data.certifname}}</a>
        </div>
        <div class="lbl_dlg" style="margin-left:10px;padding-top:7px" *ngIf="data.certifname">
          <mat-icon style="font-size:24px;margin-left: 20px; margin-right: 1em;margin-top: -20px;cursor:pointer" (click)="data.certifname=''" color="primary">delete_forever</mat-icon>
        </div>
      </div>
      <div style="float:left;clear:left;width:100%">
        <div style="float:left;clear:left;position: absolute;width:100%;z-index:1;background-color: white">
          <div style="float:left;clear:none;padding-top:5px">Carregar el certificat</div>
          <div style="float:left;clear:none">
            <label for="certif">
              <mat-icon style="font-size:24px;margin-left: 20px; margin-right: 1em;cursor:pointer" color="primary" matTooltip="L'extensió del fitxer ha de'estar en minúscules." aria-label="L'extensió del fitxer ha de'estar en minúscules." matTooltipClass="tooltip-style">cloud_upload</mat-icon></label>
          </div>
        </div>
        <div style="float:left;clear:left;position: absolute;width:100%">
          <input mat-raised-button color="primary" type="file" filter="jpg;png;doc;docx;pdf;xls;xlsx;gif;zip;rar;odt;ods;ppt;pptx" style="width:80%" placeholder="" id="certif" name="certif" (change)="onFileChange($event, 'certif')"/> (100Mb màx.)
        </div>
      </div>
-->
    </mat-card-content>

<!--
    <mat-card-content style="float:left;clear:left; width:100%;margin-bottom:40px">
      <div style="float:left;clear:left; width:100%;margin-bottom:0px">
        <div class="lbl_dlg" style="font-weight:bold;padding-top:7px;float:left;clear:left;width:300px">Imatges del projecte:</div>
<div *ngIf="imgname?.length" style="float:left;clear:none">
  <div 
    class="lbl_dlg"
    *ngFor="let img of imgname; let i = index"
    style="float:left;clear:none;margin-left:10px;margin-top:5px; display:inherit; align-items:center"
  >
  <span>
    '/assets/documents/imatges/'{{img}}
  </span>
    <img
      [attr.src]="'/assets/documents/imatges/' + img"
      [alt]="img"
      class="thumb"
      (error)="onThumbError($event)"
    />
    <div style="float:left;clear:left;">
      <mat-icon style="font-size:24px;margin-left: 20pxcursor:pointer" (click)="eliminarFitxerImatge($event, i)" color="primary">delete_forever</mat-icon>

      <mat-icon style="font-size:24px;margin-left: 20px;cursor:pointer" (click)="desarFitxer($event, img, 'documents/imatges')" color="primary">download</mat-icon>
    </div>
  </div>
</div>
    </div>
      <div style="float:left;clear:left;width:100%;padding-top:30px">
        <div style="float:left;clear:left;position: absolute;width:100%;z-index:1;background-color: white">
          <div style="float:left;clear:none;padding-top:5px">Imatges del projecte (màx. 5 que s'han de pujar juntes)</div>
          <div style="float:left;clear:none">
            <label for="img">
              <mat-icon style="font-size:24px;margin-left: 20px; margin-right: 1em;cursor:pointer" color="primary" matTooltip="L'extensió del fitxer ha de'estar en minúscules." aria-label="L'extensió del fitxer ha de'estar en minúscules." matTooltipClass="tooltip-style">cloud_upload</mat-icon></label>
          </div>
        </div>
        <div style="float:left;clear:left;position: absolute;width:100%">
          <input mat-raised-button multiple color="primary" type="file" filter="jpeg;jpg;png;gif" style="width:80%" placeholder="" id="img" name="img" (change)="onFileImgChange($event, 'img')"/> (300Kb màx.)
        </div>
      </div>
    </mat-card-content>
-->
 </form>
 <div id="exportComanda" style="float:left;clear:both;display:none;width:100%">
  <table style="float:left;clear:left;width:100%;border-collapse: collapse">
    <span *ngFor="let fitxa of fitxaComanda">
      <tr><td colspan="2" style="clear:both;font-weight:bold;width:100%;padding-top:20px;height:30px">{{ 'project-data.comanda.capcalera' | translate }}</td></tr>
      <tr><td style="color:blue;font-weight:bold;width:20%;height:30px">{{ 'project-data.comanda.client' | translate }}</td>
      <td style="float:left;clear:none;width:80%;height:30px">{{fitxa["nom"]}}</td></tr>
      <tr><td style="color:blue;font-weight:bold;width:20%;height:30px">{{ 'project-data.comanda.cif' | translate }}</td>
      <td style="float:left;clear:none;width:80%;height:30px">{{fitxa["cif"]}}</td></tr>
      <tr><td style="color:blue;font-weight:bold;width:20%;height:30px">{{ 'project-data.comanda.domicili' | translate }}</td>
      <td style="float:left;clear:none;width:80%;height:30px">{{fitxa["adreca"]}} {{fitxa["localitzacio"]}}</td></tr>
      <tr><td style="color:blue;font-weight:bold;width:20%;height:30px">{{ 'project-data.comanda.codiProjecte' | translate }}</td>
      <td style="float:left;clear:none;width:80%;height:30px">{{fitxa["clau"]}}</td></tr>
      <tr><td style="color:blue;font-weight:bold;width:20%;height:30px">{{ 'project-data.comanda.objecte' | translate }}</td>
      <td style="float:left;clear:none;width:80%;height:30px">{{fitxa["descripcio"]}}</td></tr>
      <tr><td style="color:blue;font-weight:bold;width:20%;height:30px">{{ 'project-data.comanda.dataInici' | translate }}</td>
      <td style="float:left;clear:none;width:80%;height:30px">{{fitxa["data_signatura"] | date:"d-MM-YYYY"}}</td></tr>
      <tr><td style="color:blue;font-weight:bold;width:20%;height:30px">{{ 'project-data.comanda.dataFinalitzacio' | translate }}</td>
      <td style="float:left;clear:none;width:80%;height:30px">{{fitxa["data_finalitzacio"] | date:"d-MM-YYYY"}}</td></tr>
    </span>
    </table>  
  
    <table style="float:left;clear:left;width:100%;border-collapse:collapse">
      <tr><th style="clear:both;font-weight:bold;width:100%;padding-top:20px;height:120px" colspan="3">{{ 'project-data.comanda.titolProposta' | translate }}</th></tr>
      <tr><th style="width:10%;border: 1px solid #ddd;padding: 8px">{{ 'project-data.comanda.data' | translate }}</th><th style="width:60%;border: 1px solid #ddd;padding: 8px">{{ 'project-data.comanda.treballRealitzat' | translate }}</th><th style="border: 1px solid #ddd;width:20%">{{ 'project-data.comanda.pagamentPrevist' | translate }}</th></tr>
      <tr style="height:30px"><td style="border: 1px solid #ddd;padding: 8px">&nbsp;</td><td style="border: 1px solid #ddd;padding: 8px">&nbsp;</td><td style="border: 1px solid #ddd;padding: 8px">&nbsp;</td></tr>
      <tr style="height:30px"><td style="border: 1px solid #ddd;padding: 8px">&nbsp;</td><td style="border: 1px solid #ddd;padding: 8px">&nbsp;</td><td style="border: 1px solid #ddd;padding: 8px">&nbsp;</td></tr>
      <tr style="height:30px"><td style="border: 1px solid #ddd;padding: 8px">&nbsp;</td><td style="border: 1px solid #ddd;padding: 8px">&nbsp;</td><td style="border: 1px solid #ddd;padding: 8px">&nbsp;</td></tr>
      <tr style="height:30px"><td style="border: 1px solid #ddd;padding: 8px" colspan="2">{{ 'project-data.comanda.total' | translate }}</td><td style="border: 1px solid #ddd;padding: 8px">&nbsp;</td></tr>
      <tr style="height:30px"><td style="text-align:right;border: 0px solid #ddd;padding-top:90px" colspan="2">{{ 'project-data.comanda.conformitat' | translate }}</td>
      <td style="border: 0px solid #ddd;">{{ 'project-data.comanda.barcelona' | translate:{ data: (this.diaFull | date:"EEEE d MMMM YYYY") } }}</td></tr>
    </table>
  <hr style="padding-top:40px;color:black;line-weight:bold">
</div>
</mat-card-content>
<datalist id="projectList">
  <mat-option *ngFor="let project of posssibleCodesList" value="{{project.codi}}">{{project.codi}} - {{project.titol}}</mat-option>
</datalist>
<!-- <datalist id="possibleStates">
  <mat-option *ngFor="let state of possibleStates" value="{{state}}">{{state}}</mat-option>
</datalist>
-->